import React from "react";
import { PrefillInput } from "@components/input";

export const Suburb = () => (
  <PrefillInput
    title="Suburb"
    placeholder="Suburb"
    name="suburb"
  />
);